export enum DocumentGroupEnum {
    ForIdentification = 10,
    ForApplication = 20,
    ForApproval = 25,
    ForMortgage = 30,
    ForDrawing = 40,
    AfterDrawing = 50,
}
